import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ToasterService } from '../../services/toaster.service';
import { validateEmail } from '../../@theme/directives/validators';
import { MessagesService } from '../../services/messages.service';
import { AnalyticsService } from '../../@core/utils';

@Component({
  selector: 'ngx-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  randomCode: any;
  isPassword = false;
  isCodeVerified = false;
  loading = false;
  isShowPassword = false;
  isShowPasswordText = false;
  isShowConfirmPasswordText = false;
  currentUser;
  @Output() isResetPassword = new EventEmitter<boolean>();
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private toasterService: ToasterService,
    private messageService: MessagesService,
    public analyticsService: AnalyticsService
  ) { }

  ngOnInit(): void {
    this.getFormControls();

    this.authService.openResetPasswordModal.subscribe((x) => {
      if (x) {
        this.resetPasswordForm.reset();
        this.isPassword = false;
        this.isCodeVerified = false;
        this.isShowPassword = false;
      }
    });
  }

  getFormControls() {
    this.resetPasswordForm = this.fb.group({
      email: ['', [Validators.required, validateEmail]],
      code: ['', Validators.required],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
  }

  async sendCodeToEmail() {
    try {
      this.loading = true;
      this.currentUser = await this.authService.userByEmail({
        email: this.resetPasswordForm.value.email,
      });

      if (this.currentUser && this.currentUser.length > 0) {
        this.randomCode = this.getRandomNumber();

        const body = {
          subject: 'Reset Password Code RespondEDU Portal Web',
          text: `Your Reset Password Code is ${this.randomCode}`,
          to: this.resetPasswordForm.value.email,
        };

        const response = await this.messageService.sendEmail(body);

        if (response && response.message === 'Email sent successfully') {
          this.toasterService.showToast(
            'Code sent to your Email Address',
            'success'
          );
          this.isPassword = true;
        } else {
          this.toasterService.showToast(
            'Something went wrong, Please try again after some time',
            'danger'
          );
        }
      } else {
        this.toasterService.showToast(
          'User not found for current Email Address',
          'danger'
        );
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  verifyCode() {
    if (Number(this.resetPasswordForm.value.code) === this.randomCode) {
      this.toasterService.showToast('Code Verified Successfully', 'success');
      this.isCodeVerified = true;
      this.isShowPassword = true;
    } else {
      this.toasterService.showToast('Invalid Code', 'danger');
      this.isShowPassword = false;
      this.isCodeVerified = false;
    }
  }

  async resetPassword() {
    try {
      this.loading = true;
      console.log('🚀 ~ ForgotPasswordComponent ~ resetPassword ~ body.this.currentUser:', this.currentUser)
      const body = {
        user_id: this.currentUser[0].id,
        firstName: this.currentUser[0].firstName,
        lastName: this.currentUser[0].lastName,
        email: this.currentUser[0].email,
        password: this.resetPasswordForm.value.password,
        role_id: this.currentUser[0].role_id,
        school_id: this.currentUser[0].school_id,
        isNewUser: this.currentUser[0].isNewUser,
        profileData: this.currentUser[0].profileData,
        teachingInfo: this.currentUser[0].teachingInfo,
        user_profile_media_id: this.currentUser[0].user_profile_media_id,
        contact: this.currentUser[0].contact,
        address: this.currentUser[0].address,
        birthdate: this.currentUser[0].birthdate,
        proxy_email: this.currentUser[0].proxy_email,
        provider_id: this.currentUser[0].provider_id,
        uid: this.currentUser[0].uid,
      };

      const response = await this.authService.updateUserWithPassword(
        this.currentUser[0].id,
        body
      );

      if (response && response.id) {
        this.toasterService.showToast('Password Reset Successfully', 'success');
        this.resetPasswordForm.reset();
        this.isPassword = false;
        this.isCodeVerified = false;
        this.isShowPassword = false;
        this.isResetPassword.emit(true);
      } else {
        this.toasterService.showToast(
          'Something went wrong, Please try again after some time',
          'danger'
        );
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  getRandomNumber() {
    return Math.floor(Math.random() * 90000) + 10000;
  }
}
